import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiStar,FiHeart,FiGift,FiTool,FiRefreshCw,FiShield}=FiIcons;

const Services=()=> {
  const services=[
    {icon: FiHeart,title: 'Engagement Rings',description: 'Custom-designed engagement rings that capture your unique love story with premium diamonds and precious metals.',features: ['Custom Design','Premium Diamonds','Lifetime Warranty','Free Resizing']},
    {icon: FiGift,title: 'Wedding Bands',description: 'Matching wedding bands crafted to perfection,symbolizing your eternal bond with exquisite detail.',features: ['Matching Sets','Custom Engraving','Multiple Metals','Perfect Fit Guarantee']},
    {icon: FiStar,title: 'Fine Necklaces',description: 'Elegant necklaces featuring precious stones and metals,designed to complement your natural beauty.',features: ['Precious Stones','Adjustable Length','Hypoallergenic','Gift Packaging']},
    {icon: FiTool,title: 'Custom Design',description: 'Bring your vision to life with our custom jewelry design service,from concept to creation.',features: ['3D Design Preview','Expert Consultation','Unlimited Revisions','Premium Materials']},
    {icon: FiRefreshCw,title: 'Jewelry Repair',description: 'Professional repair and restoration services to bring your precious pieces back to their original glory.',features: ['Expert Restoration','Quick Turnaround','Quality Guarantee','Free Estimates']},
    {icon: FiShield,title: 'Appraisal Services',description: 'Certified jewelry appraisals for insurance,resale,or personal knowledge with detailed documentation.',features: ['Certified Appraisers','Insurance Documentation','Market Value Assessment','Digital Certificates']}
  ];

  const galleryImages=[
    'https://i.ibb.co/GvnMVSqM/Anni-Jewelry-images-1.jpg',
    'https://i.ibb.co/GfBC0Pcg/Anni-Jewelry-images-2.jpg',
    'https://i.ibb.co/C58185Tb/Anni-Jewelry-images-3.jpg',
    'https://i.ibb.co/0Vmyx6YY/Anni-Jewelry-images-4.jpg',
    'https://i.ibb.co/ymD5Cs9S/Anni-Jewelry-images-5.jpg',
    'https://i.ibb.co/HfJ35YZx/Anni-Jewelry-images-6.jpg',
    'https://i.ibb.co/Zz3fBtwK/Anni-Jewelry-images-7.jpg',
    'https://i.ibb.co/QFG9nbNv/Anni-Jewelry-images-8.jpg',
    'https://i.ibb.co/9H2kbSXj/Anni-Jewelry-images-9.jpg',
    'https://i.ibb.co/v4gt2866/Anni-Jewelry-images-10.jpg',
    'https://i.ibb.co/pTX6ZWq/Anni-Jewelry-images-11.jpg',
    'https://i.ibb.co/TMTgZzHt/Anni-Jewelry-images-12.jpg'
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-black via-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            className="text-5xl md:text-6xl font-bold text-white mb-6 font-playfair"
          >
            Our <span className="text-gold">Services</span>
          </motion.h1>
          <motion.p
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.2}}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            From custom engagement rings to professional repairs,we offer comprehensive jewelry services with exceptional craftsmanship and personalized attention to every detail.
          </motion.p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="bg-gray-900 p-8 rounded-lg border border-gold/20 hover:border-gold/50 transition-all duration-300 hover:shadow-gold"
              >
                <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-6">
                  <SafeIcon icon={service.icon} className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-2xl font-bold text-gold mb-4 font-playfair">{service.title}</h3>
                <p className="text-gray-300 mb-6">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature,idx)=> (
                    <li key={idx} className="flex items-center text-gray-400">
                      <SafeIcon icon={FiStar} className="w-4 h-4 text-gold mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-playfair">
              Our <span className="text-gold">Portfolio</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore our stunning collection of handcrafted jewelry pieces,each telling a unique story of elegance,beauty,and exceptional craftsmanship.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryImages.map((image,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,scale: 0.8}}
                whileInView={{opacity: 1,scale: 1}}
                transition={{duration: 0.8,delay: index * 0.05}}
                viewport={{once: true}}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg bg-black/50 border border-gold/20 hover:border-gold/50 transition-all duration-300">
                  <img src={image} alt={`Jewelry Portfolio ${index + 1}`} className="w-full h-64 object-cover image-hover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4">
                      <p className="text-white font-semibold">Premium Jewelry</p>
                      <p className="text-gray-300 text-sm">Handcrafted Excellence</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-playfair">
              Our <span className="text-gold">Process</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              From initial consultation to final delivery,we ensure every step meets our high standards of quality and exceeds your expectations.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {step: '01',title: 'Consultation',description: 'Discuss your vision and requirements with our experts'},
              {step: '02',title: 'Design',description: 'Create detailed designs and 3D previews of your piece'},
              {step: '03',title: 'Crafting',description: 'Handcraft your jewelry with precision and care'},
              {step: '04',title: 'Delivery',description: 'Present your finished piece with certification'}
            ].map((item,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center"
              >
                <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-black">{item.step}</span>
                </div>
                <h3 className="text-xl font-bold text-gold mb-4">{item.title}</h3>
                <p className="text-gray-300">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;